<section id="intro_mobile_dev" class="section-bg-dark">
  <div class="container-fluid">
    <div class="row">
      <div _ngcontent-fac-c9="" class="col-xs-12 pl-4">
        <h2 class="text-white">ESTRATEGIA Y CRECIMIENTO DIGITAL</h2>
      </div>
    </div>
  </div>
</section>
<section id="mobile_proyect">
  <div class="container">
    <div class="row mb-3">
      <div class="col-xs-12 col-sm-12">
        <p class="font-medium">
          Ayudamos a las empresas a crecer en entornos digitales mediante estrategias de marketing
          orientadas a resultados, optimizando la captación, conversión y fidelización de clientes.
        </p>
      </div>
    </div>
  </div>  

  <div class="container img-claim">
    <div class="row">
      <img alt="" src="assets/img/proyect_app_mobile.webp">
    </div>
  </div>

  <div class="container">
    <div class="row justify-content-between">
      @for (card of cards; track card) {
      <div class="card col-sm-12 col-md-4 text-center p-2">

        <div class="card-body">
          <div class="border_box">

            <h5>{{ card.title }}</h5>
            <p>
              {{ card.text }}
            </p>
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-xs-12 w-100 text-center mt-10">
        <h2>HERRAMIENTAS QUE UTILIZAMOS</h2>
      </div>
    </div>
    <br>
    <div class="carousel slide carousel-multi-item" data-ride="carousel" role="listbox" data-interval="1500">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <div class="row logos">
            @for (carousel of carousels; track carousel) {
              <div class="col-xs-3 col-md-3">
              <img src="{{ carousel.src }}" alt="{{ carousel.alt }}" class="icons_standar">
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row justify__content-center">
      <div class="col-6 mt-10">
        <button class="btn_help" routerLink="/contacto">¿Te ayudamos?</button>
      </div>
    </div>
  </div>
</section>